import { PERMISSION } from '@/constants/permission.constant';

const list = () => import('@/views/after-sale/List.vue');
const edit = () => import('@/views/after-sale/Edit.vue');

export const afterSaleRoute = [
  {
    path: '/inbox/after-sales',
    name: 'after-sales-list',
    component: list,
    meta: { requiresAuth: false, permissions: [PERMISSION.SERVICE_READ] },
  },
  {
    path: '/inbox/after-sales/:id/edit',
    name: 'after-sales-update',
    component: edit,
    meta: { requiresAuth: false, permissions: [PERMISSION.SERVICE_UPDATE] },
  },
];
